import { FC } from 'react'
import { Modal } from 'antd'
import { useTargetTemplateModalStore } from './TargetTemplateModalStore'
import { TargetTemplateModalHeader } from './TargetTemplateModalHeader'
import { TargetTemplateModalFooter } from './TargetTemplateModalFooter'
import { TargetTemplateModalContent } from './TargetTemplateModalContent'

export const TargetTemplateModal: FC = () => {
  const isTargetTemplateModalOpened = useTargetTemplateModalStore((state) => state.isTargetTemplateModalOpened)

  return (
    <Modal
      title={<TargetTemplateModalHeader />}
      visible={isTargetTemplateModalOpened}
      closable={false}
      footer={<TargetTemplateModalFooter />}
      destroyOnClose
      className="per-modal per-modal--large"
    >
      <TargetTemplateModalContent />
    </Modal>
  )
}
